import {
  LuSmartphone,
  LuClock,
  LuBuilding2,
  LuUsers,
  LuWallet,
  LuCpu,
  LuClipboardList,
  LuPalette,
  LuCode,
  LuBug,
  LuRocket,
  LuSettings,
  LuShieldCheck,
  LuShield,
  LuPercent,
} from "react-icons/lu";

export const BrandPositioningHeroData = {
  backgroundImage: "/images/serviceBanners/BrandPromotion.webp",
  whiteImage: "/images/serviceBanners/BrandPromotionW.webp",
  subTitle: "Brand Positioning & Promotion Services",
  title: (
    <>
      High Performance <br /> <span className="text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-purple-600">Brand Positioning</span> System
    </>
  ),
  description:
    "We build strong brand positioning and promotion systems that define clear market space, enhance perception, and strengthen long term brand authority through strategic messaging, audience insights, and consistent brand growth execution.",
  primaryButton: {
    title: "Get a Free Quote",
    onClick: () => console.log("Get a Free Quote clicked"),
  },
  secondaryButton: {
    title: "View Our Work",
    onClick: () => console.log("View Our Work clicked"),
  },
  featureData: [
    {
      icon: "/images/services/website/high_performance.webp",
      title: "Market Positioning Strategy",
      desc: "Define unique value proposition, target audience, and clear brand positioning.",
      iconColor: "#a855f7",
    },
    {
      icon: "/images/services/website/responsive.webp",
      title: "Competitor Analysis System",
      desc: "Deep research to identify market gaps, competitor strengths, and positioning opportunities.",
      iconColor: "#22d3ee",
    },
    {
      icon: "/images/services/website/secure.webp",
      title: "Go To Market Planning",
      desc: "Plan and execute structured GTM launch strategies across digital, offline, and PR channels.",
      iconColor: "#a855f7",
    },
    {
      icon: "/images/services/website/clean_code.webp",
      title: "Brand Narrative Development",
      desc: "Create compelling brand stories that build emotional connection, trust, and brand recall.",
      iconColor: "#34d399",
    },
  ],
  floatingIcons: [
    {
      image: "/images/services/website/nodejs.webp",
      top: "16%",
      right: "8%",
      containerSize: 80,
      iconSize: 60,
      glowColor: "rgba(59,130,246,0.35)",
      iconGlow: "rgba(59,130,246,0.9)",
    },
  ],
};

export const brandPositioningStatsData = [
  {
    icon: LuSettings,
    value: "140+",
    label: "Positions Engineered",
    colorClass: "text-[#00d2ff]",
    bgClass: "bg-[#00d2ff]/10",
    borderClass: "border-[#00d2ff]/20",
    glowClass: "shadow-[0_0_20px_rgba(0,210,255,0.15)]",
  },
  {
    icon: LuUsers,
    value: "95+",
    label: "Brands Promoted",
    colorClass: "text-[#a855f7]",
    bgClass: "bg-[#a855f7]/10",
    borderClass: "border-[#a855f7]/20",
    glowClass: "shadow-[0_0_20px_rgba(168,85,247,0.15)]",
  },
  {
    icon: LuSmartphone,
    value: "45M+",
    label: "Total Impressions",
    colorClass: "text-[#06b6d4]",
    bgClass: "bg-[#06b6d4]/10",
    borderClass: "border-[#06b6d4]/20",
    glowClass: "shadow-[0_0_20px_rgba(6,182,212,0.15)]",
  },
  {
    icon: LuShieldCheck,
    value: "99.9%",
    label: "Narrative Alignment",
    colorClass: "text-[#3b82f6]",
    bgClass: "bg-[#3b82f6]/10",
    borderClass: "border-[#3b82f6]/20",
    glowClass: "shadow-[0_0_20px_rgba(59,130,246,0.15)]",
  },
  {
    icon: LuPercent,
    value: "50%",
    label: "Recall Increase",
    colorClass: "text-[#d946ef]",
    bgClass: "bg-[#d946ef]/10",
    borderClass: "border-[#d946ef]/20",
    glowClass: "shadow-[0_0_20px_rgba(217,70,239,0.15)]",
  },
  {
    icon: LuShield,
    value: "100%",
    label: "Market Advantage",
    colorClass: "text-[#6366f1]",
    bgClass: "bg-[#6366f1]/10",
    borderClass: "border-[#6366f1]/20",
    glowClass: "shadow-[0_0_20px_rgba(99,102,241,0.15)]",
  },
];

export const brandPositioningSolutionsAndProcessData = {
  buildSubtitle: "WHAT WE DELIVER",
  buildTitle: "Brand Positioning Solutions for Every Business Requirement",
  buildCards: [
    {
      title: "Market & Competitor Analysis",
      desc: "Deep research to identify market gaps, competitor strengths, and positioning opportunities.",
      icon: LuSmartphone,
      colorClass: "text-[#00d2ff]",
      bgClass: "bg-[#00d2ff]/10",
      borderClass: "border-[#00d2ff]/20 hover:border-[#00d2ff]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(0,210,255,0.25)]",
    },
    {
      title: "Positioning Strategy Development",
      desc: "Define unique value proposition, target audience, and clear brand positioning.",
      icon: LuClock,
      colorClass: "text-[#3b82f6]",
      bgClass: "bg-[#3b82f6]/10",
      borderClass: "border-[#3b82f6]/20 hover:border-[#3b82f6]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(59,130,246,0.25)]",
    },
    {
      title: "Go-To-Market (GTM) Campaigns",
      desc: "Plan and execute structured launch strategies across digital, offline, and PR channels.",
      icon: LuBuilding2,
      colorClass: "text-[#a855f7]",
      bgClass: "bg-[#a855f7]/10",
      borderClass: "border-[#a855f7]/20 hover:border-[#a855f7]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(168,85,247,0.25)]",
    },
    {
      title: "Brand Storytelling & Narrative Design",
      desc: "Create compelling brand stories that build emotional connection and trust.",
      icon: LuUsers,
      colorClass: "text-[#06b6d4]",
      bgClass: "bg-[#06b6d4]/10",
      borderClass: "border-[#06b6d4]/20 hover:border-[#06b6d4]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(6,182,212,0.25)]",
    },
    {
      title: "Audience Positioning Insights",
      desc: "Understand customer behavior and perception to refine brand positioning strategy.",
      icon: LuWallet,
      colorClass: "text-[#6366f1]",
      bgClass: "bg-[#6366f1]/10",
      borderClass: "border-[#6366f1]/20 hover:border-[#6366f1]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(99,102,241,0.25)]",
    },
    {
      title: "Brand Growth Optimization",
      desc: "Continuously improve brand visibility, perception, and market impact.",
      icon: LuCpu,
      colorClass: "text-[#d946ef]",
      bgClass: "bg-[#d946ef]/10",
      borderClass: "border-[#d946ef]/20 hover:border-[#d946ef]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(217,70,239,0.25)]",
    },
  ],
  processSubtitle: "Brand Engineering Framework",
  processTitle: "How We Build Scalable Brand Systems",
  processSteps: [
    {
      step: "01",
      title: "Brand Architecture Planning",
      description: "Define brand structure, positioning roadmap, and long-term growth direction.",
      icon: LuUsers,
    },
    {
      step: "02",
      title: "Agile Brand Execution",
      description: "Develop and refine brand systems in iterative cycles for continuous improvement.",
      icon: LuClipboardList,
    },
    {
      step: "03",
      title: "Identity System Development",
      description: "Create reusable brand elements including visuals, messaging, and communication systems.",
      icon: LuPalette,
    },
    {
      step: "04",
      title: "Brand Communication Management",
      description: "Maintain consistent tone, storytelling, and messaging across all platforms.",
      icon: LuCode,
    },
    {
      step: "05",
      title: "Brand Performance Optimization",
      description: "Improve brand perception, visibility, and market impact using insights and analysis.",
      icon: LuBug,
    },
    {
      step: "06",
      title: "Quality & Consistency Assurance",
      description: "Ensure strong brand alignment across all channels and customer touchpoints.",
      icon: LuRocket,
    },
  ],
  benefitsSubtitle: "WHY INVEST IN BRAND SYSTEMS?",
  benefitsTitle: "Why Businesses Invest in Brand Systems",
  benefits: [
    "Strong market positioning",
    "Consistent brand identity",
    "Better customer trust and recall",
    "Scalable communication system",
    "Long-term brand authority",
    "Competitive market advantage",
    "Sustainable business growth",
  ],
  logoImage: "/images/serviceBanners/DigitalMarketingLatest.webp",
  whiteLogoImage: "/images/serviceBanners/digitalMarketingLatestW.webp",
};

export const brandPositioningPortfolioData = {
  subtitle: "OUR WORK",
  title: "Positioning Campaigns We're Proud Of",
  buttonText: "View Case Studies",
  buttonLink: "#all-projects",
  apps: [
    {
      title: "Foodie Express",
      badge: "Food Delivery App",
      badgeColor: "bg-[#00d2ff]/10 text-[#00d2ff] border-[#00d2ff]/20",
      desc: "A fast and intuitive food delivery app with real-time tracking, secure payments & smooth experience.",
      downloads: "100K+",
      rating: "4.8",
      image: "/images/MobileAppDevelopment/foodie_express.png",
    },
    {
      title: "FinMate",
      badge: "FinTech App",
      badgeColor: "bg-[#a855f7]/10 text-[#a855f7] border-[#a855f7]/20",
      desc: "A personal finance app to manage expenses, budgets & investments with advanced analytics.",
      downloads: "250K+",
      rating: "4.9",
      image: "/images/MobileAppDevelopment/finmate.png",
    },
    {
      title: "TravelGo",
      badge: "Travel App",
      badgeColor: "bg-[#3b82f6]/10 text-[#3b82f6] border-[#3b82f6]/20",
      desc: "A travel booking app for flights, hotels & packages with best deals and easy bookings.",
      downloads: "500K+",
      rating: "4.7",
      image: "/images/MobileAppDevelopment/travelgo.png",
    },
  ],
};

export const brandPositioningTechnologiesData = {
  techTitle: "OUR BRANDING TOOL STACK",
  technologies: [
    { name: "Brand Guidelines", icon: "Search" },
    { name: "Figma", icon: "Provider" },
    { name: "Adobe Photoshop", icon: "Vite" },
    { name: "Adobe Illustrator", icon: "Palette" },
  ],
  trustTitle: "TRUSTED BY GOOGLE PARTNERS",
  trustClients: [
    { image: "/images/logo/google_logo.png", alt: "google_logo" },
    { image: "/images/logo/microsoft_logo.png", alt: "microsoft_logo" },
    { image: "/images/logo/amazon_logo.png", alt: "amazon_logo" },
    { image: "/images/logo/Adobe_Corporate_logo.png", alt: "adobe_logo" },
    { image: "/images/logo/IBM_logo.png", alt: "ibm_logo" },
    { image: "/images/logo/Oracle_logo.png", alt: "oracle_logo" },
  ],
};

export const brandPositioningAboutData = [
  {
    title: "Brand Positioning Services for Stronger Market Recognition",
    content: (
      <>
        A successful brand earns a place in the minds of customers through clarity, trust, and consistent value. Professional Brand Positioning Services help businesses define what
        makes them different and why customers should choose them over competitors. Many organizations offer excellent products or services but struggle to communicate their value
        effectively in crowded markets. At <b className="text-text-primary font-semibold">Tycho Technologies</b>, positioning strategies are developed around customer perception,
        market opportunities, and business strengths to help brands establish a meaningful and lasting presence.
      </>
    ),
  },
  {
    title: "Brand Strategy Services That Create Competitive Advantage",
    content: (
      <>
        Strong brands are built through thoughtful planning and a deep understanding of customer expectations. Reliable Brand Strategy Services help businesses identify their
        unique strengths, refine their market approach, and create a clear direction for future growth. Companies investing in strategic brand development often improve customer
        confidence because their messaging becomes more focused and consistent. Tycho Technologies helps organizations create structured brand frameworks that support stronger
        differentiation and long term market relevance.
      </>
    ),
  },
  {
    title: "Brand Promotion Services for Greater Visibility",
    content: (
      <>
        Even the strongest brand requires effective promotion to reach the right audience. Professional Brand Promotion Services help businesses increase awareness, strengthen
        credibility, and create more opportunities for customer engagement. Organizations that invest in strategic promotion often improve market reach because their brand message
        is delivered consistently across multiple channels. A well executed promotion strategy helps businesses build recognition, strengthen audience relationships, and support
        long term business objectives.
      </>
    ),
  },
  {
    title: "Why Businesses Choose Brand Consulting Services",
    content: (
      <>
        The demand for expert Brand Consulting Services continues to grow as businesses seek stronger positioning and sustainable market influence. Companies working with a trusted{" "}
        <b className="text-text-primary font-semibold">Branding Agency India</b> often focus on refining customer perception, improving competitive differentiation, and
        strengthening brand authority. Businesses partnering with Tycho Technologies gain access to customized branding frameworks designed around measurable business goals and
        market realities. A strategic approach to brand positioning helps organizations improve recognition, build trust, and create long term business value.
      </>
    ),
  },
];

export const brandPositioningFaqData = [
  {
    q: "What is brand positioning, and why is it important for business growth?",
    a: "Brand positioning is the process of defining how customers perceive your business compared to competitors. Effective positioning helps businesses stand out in crowded markets, attract the right audience, and build long-term customer trust.",
  },
  {
    q: "How can brand promotion services improve market visibility?",
    a: "Brand promotion services help businesses increase awareness through strategic marketing, communication, and audience engagement activities. Consistent promotion strengthens brand recall, credibility, and customer reach across multiple channels.",
  },
  {
    q: "What factors should be considered when developing a brand positioning strategy?",
    a: "A successful brand positioning strategy should consider target audience needs, competitor positioning, unique value propositions, market trends, customer perception, and long-term business objectives.",
  },
  {
    q: "How does Tycho Technologies help businesses create a strong market position?",
    a: "Tycho Technologies develops customized positioning frameworks using market research, competitor analysis, audience insights, and brand storytelling strategies to help businesses establish a clear and differentiated market presence.",
  },
  {
    q: "Why do businesses choose Tycho Technologies for brand positioning and promotion services?",
    a: "Businesses choose Tycho Technologies because of its structured approach to brand strategy, promotion planning, and market positioning. The focus is on building sustainable brand authority, improving customer perception, and supporting measurable business growth.",
  },
];
